export default __webpack_public_path__ + "static/media/uyo-terminal.8e690540.png";